export default __webpack_public_path__ + "static/media/redeemed.c0ed12ff.png";